import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Question } from "@phosphor-icons/react";

export const InfoHint = ({ text, side = "top" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid="info-hint"
        onClick={(e) => e.stopPropagation()}
        aria-label="Что это значит?"
        className="inline-flex shrink-0 items-center justify-center text-muted-foreground/70 hover:text-primary transition-colors align-middle ml-1.5"
      >
        <Question size={15} weight="duotone" />
      </button>
    </PopoverTrigger>
    <PopoverContent side={side} sideOffset={6} collisionPadding={12} className="glass-modal max-w-[290px] text-xs leading-relaxed text-foreground/90 p-3.5" data-testid="info-hint-content">
      {text}
    </PopoverContent>
  </Popover>
);
